<template>
  <div :style="{height: `${item.height}px`}" :class="classList" @click="onClick" @dblclick="onDblClick">
    <div class="td">
      <div class="info" :title="item.value.id && `#${item.value.id}`" @click="debug && $console.log('item: %o', item)">
        <template v-if="item.value.errors">
          <div :title="item.value.getErrorTitle()">
            <svg-icon icon-class="errorCircleBlack" />
          </div>
        </template>
        <template v-else>
          <svg-icon v-if="isPlanner && item.value && (isGeoPointPort(item.value.arrPortId) || isGeoPointPort(item.value.depPortId))" icon-class="map" style="color: #f38b00"/>
          <svg-icon v-else-if="item.type === 'person'" icon-class="personCircle" />
          <svg-icon v-else-if="item.type === 'cargo'" icon-class="package2" />
        </template>
      </div>
    </div>

    <ul v-if="cColumns" class="item-columns">
      <template v-for="column in cColumnsValues">
        <li :key="column.key" :data-col-key="column.key">
          <el-divider direction="vertical" />
          <div :class="['info', column.key]" :style="getColStyle(column.key, item.type)" :title="!editMode ? column.value : null">
            <flight-order-row-cell
              v-if="false && editMode"
              :disp-key="column.key"
              :disp-value="column.value + ''"
              :flight-order="item.value._flightOrder"
            />
            <slot v-else-if="column.useSlot" :name="column.slotName" />
            <span v-else>{{ column.value }}</span>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
// npm
import { get } from 'lodash'
//
import { renderColumns } from '@/components/flight-orders/scrolled/flightOrderRowRenderer'
import FlightOrderRowCell from '@/components/flight-orders/scrolled/FlightOrderRowCell'
import store from '@/store'
import { hasRole } from '@/utils/user'

export default {
  components: {FlightOrderRowCell},
  props: ['item', 'index', 'columns', 'options', 'editMode', 'tableKeyPrefix', 'colWidth', 'modified'],
  data: () => ({
    colMinWidth: {
      'flightDateString': 75,
      'depPortLabels.code': 40,
      'arrPortLabels.code': 40,
      'from': 150,
      'to': 150,
      'pnr': 45,
      'shortName': 110,
      'orderData.fullName': 250,
      'orderData.docNum': 70,
      'orderData.name': 100,
      'orderData.mvz': 50,
      'birthDateStr': 75,
      'orderData.contacts': 100,
      'orderData.email': 100,
      'orderData.timeFrom': 50,
      'processData.orderStatus': 100,
      'orderData.initiator': 70,
      'orderData.initiatorEmail': 70,
      'orderData.initiatorPhone': 70,

      'orderData.transportType': 50,
      'orderData.packType': 70,
      'orderData.dimensions': 140,
      'organization': 140,
      'orderData.weight': 60,
      'orderData.placeCount': 30,

      'medcheck': 110,
      'registered': 100
    }
  }),

  computed: {
    classList () {
      const gp = store.getters.settings['GPN_GEO_POINT_PORT_ID']
      return [
        'tr',
        this.item.type,
        ((this.isPlanner && (this.item.value.arrPortId === gp || this.item.value.depPortId === gp)) ? 'geo-point' : ''),
        (this.item.value.grouped ? 'item-grouped' : ''),
        (this.item.recentlyUpdated || this.modified ? 'item-recently-updated' : ''),
        (this.item.selected ? 'item-selected' : '')
      ]
    },
    cColumns () {
      return this.item.type === 'person' ? this.cPersonColumns : this.cCargoColumns
    },
    cColumnsValues () {
      return renderColumns(this.item.value, this.cColumns)
    },
    cPersonColumns () {
      let columns = this.$store.getters.tableColumns.columns.getOrDefault(
        this.tableKeyPrefix + '-personColumns',
        [
          // route
          'flightDateString',
          'depPortLabels.code',
          'arrPortLabels.code',
          // passenger data
          'pnr',
          'shortName',
          'orderData.docNum',
          'orderData.mvz',
          'organization',
          'birthDateStr',
          'orderData.contacts',
          'orderData.email',
          // initiator
          'orderData.initiator',
          'orderData.initiatorEmail',
          'orderData.initiatorPhone',
          //
          'orderData.timeFrom',
          //
          'processData.orderStatus'
        ]
      )
      return columns
    },
    cCargoColumns () {
      let columns = this.$store.getters.tableColumns.columns.getOrDefault(
        this.tableKeyPrefix + '-cargoColumns',
        [
          'flightDateString', 'depPortLabels.code', 'arrPortLabels.code',
          'pnr',
          'orderData.placeCount',
          'orderData.name',
          'orderData.dimensions',
          'orderData.weight',
          //
          'orderData.mvz',
          'organization',
          //
          'orderData.packType',
          'orderData.transportType',
          // initiator
          'orderData.initiator',
          'orderData.initiatorEmail',
          'orderData.initiatorPhone',
          //
          'orderData.timeFrom',
          //
          'processData.orderStatus'
        ]
      )
      return columns
    },
    isPlanner () {
      this.debug && console.log('PLANNER: ', hasRole('PLANNER'))
      return hasRole('PLANNER')
    }
  },
  methods: {
    getColStyle (key, itemType) {
      let type = null
      if (itemType === 'person') {
        type = 'columnWidthPerson'
      } else if (itemType === 'cargo') {
        type = 'columnWidthCargo'
      }
      if (this.colWidth !== {}) {
        return this.colWidth[type][key] ? {'width': this.colWidth[type][key] + 'px'} : null
      } else {
        return this.colMinWidth[key] ? {'width': this.colMinWidth[key] + 'px'} : null
      }
    },
    onClick (event) {
      if (this.item.inactive !== true) {
        this.$emit('click:item', this.item, event)
      }
    },
    onDblClick () {
      this.$emit('dblclick:item', this.item)
    },
    isGeoPointPort (portId) {
      const gp = store.getters.settings.GPN_GEO_POINT_PORT_ID
      return portId === gp
    }
  }
}
</script>

<style scoped>
  .index {
    color: rgba(0, 0, 0, 0.2);
    width: 55px;
    text-align: right;
    flex: auto 0 0;
  }

  .person .td:first-child,
  .cargo .td:first-child {
    padding: 6px;
  }

  .info {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    margin-top: auto;
    margin-bottom: auto;
  }

  .avatar {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }

  .p-left {
    padding-left: 10px;
  }

  .item-columns {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin-right: 6px;
    padding: 0;
  }
  .item-columns li {
    /*height: 20px;*/
    /*opacity: .54;*/
    /*width: 20px;*/
    /*opacity: .54;*/
    /*align-items: center;*/
    border: none;
    display: inline-flex;
    /*justify-content: center;*/
    outline: none;
    position: relative;
    z-index: 0;
    /*cursor: pointer;*/
    list-style: none;
    /*margin: 0 10px;*/

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tr {
    transition: 1s;
    transition-property: background-color;
    /* see and fix https://stackoverflow.com/questions/9509002/css-transition-when-class-removed */
  }

  .item-grouped {
    transition: none;
    background-color: #3fbfad29;
  }
  .item-selected {
    transition: none;
    background-color: #f3f3f3;
    font-weight: 700;
  }
  .item-selected.item-grouped {
    background-color: #3fbfad4f;
  }
  .item-recently-updated {
    background-color: #ffedae;
    transition: none;
  }
  .geo-point {
    background-color: rgba(243, 139, 0, 0.20)
  }

  .td .info .svg-icon {
    width: 1.4rem;
    height: 1.4rem;
  }

  /*edit cell inputs*/
  .item-columns >>> .el-input--mini  {
    width: 100%;
  }
  .item-columns >>> .el-input--mini input {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    font-size: 0.8rem;
    height: 1rem;
    border: none;
  }

  >>> .el-divider--vertical {
    margin: auto 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/FlightOrderRow.vue